import { Component } from '@angular/core';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrl: './footer.component.css'
})
export class FooterComponent {
  currentYear = new Date().getFullYear();
  socialMedia = [
    {
      icon: 'icofont icofont-social-whatsapp'
    }
  ]
}
